import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { translate } from "react-i18next";

import Icon from "ia.react.icons";

export class SectionConfirmation extends Component {
  constructor(props) {
    super(props);

    //clear session data
    //sessionStorage.clear();
  }

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Row height="12">
          <Col sm="12">
            <h1>{t("section_confirmation.header1")}</h1>
            <h3>{t("section_confirmation.header2")}</h3>
            <br />
            <Icon icon="CHECKED" size={100} color="#008000" />
            <br /> <br />
            {t("section_confirmation.paragraph1")}
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default translate("translate")(SectionConfirmation);
